import { Component, Input } from '@angular/core';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthorisedSideNavService } from '@app/core/services/authorised-side-nav.service';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { AuthStatusService } from '@app/core/services/auth-status.service';
import { NotificationService } from '@app/core/services/notification.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-side-navbar',
  templateUrl: './side-navbar.component.html',
  styleUrls: ['./side-navbar.component.scss']
})
export class SideNavbarComponent {

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );

  activeNew = false;
  activeNewSecond = false;
  ENABLE_LIVESTREAM_TAB:boolean;


  @Input()
  role: string;
  @Input()
  name: string;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private authService: AuthService,
    private authStatusService: AuthStatusService,
    private notificationService: NotificationService,
    public sideNavService: AuthorisedSideNavService
  ) { }

  ngOnInit() {
    this.ENABLE_LIVESTREAM_TAB= environment.ENABLE_LIVESTREAM_TAB;
  }

  redirectToScan() {
    if(this.isKioskEnabled()){
      this.router.navigate([`scan-cargo/scan-cargo-guided-init`]);
    }else if(!this.isKioskEnabled() && this.isPiecewiseGuidedEnabled()){
      this.router.navigate([`scan-cargo/scan-cargo-piecewise-init`]);
    }else{
      this.router.navigate([`scan-cargo`]);
    }
    this.activeNewSecond = true;
    this.activeNew = false;
  }

  redirectToDashboard() {
    this.router.navigate([`dashboard`]);
    this.activeNew = true;
    this.activeNewSecond = false;
  }

  logout() {
    localStorage.clear();
    this.authStatusService.setState(false);
    this.router.navigate(['/login']);
  }

  isKioskEnabled(){
    if(environment.KIOSK_ENABLED && typeof(environment.KIOSK_ENABLED)==="string"){
      return environment.KIOSK_ENABLED.toLowerCase()==="true";
    }
    return false;
  }

  isPiecewiseGuidedEnabled(){
    if(environment.PIECEWISE_GUIDED_ENABLED && typeof(environment.PIECEWISE_GUIDED_ENABLED)==="string"){
      return environment.PIECEWISE_GUIDED_ENABLED.toLowerCase()==="true";
    }
    return false;
  }

  isAdmin(){
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    return userDetails && userDetails.roleCode === "admin";
  }
}

